import { render, staticRenderFns } from "./MCountYear.vue?vue&type=template&id=224907d8&scoped=true&"
import script from "./MCountYear.vue?vue&type=script&lang=js&"
export * from "./MCountYear.vue?vue&type=script&lang=js&"
import style0 from "./MCountYear.vue?vue&type=style&index=0&id=224907d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224907d8",
  null
  
)

export default component.exports